const meetingApi = '/meeting';

export const activeUserMeetingsAPI = () => meetingApi;
